import React, { useEffect, useState } from 'react'
import axiosInstance from '../../../../services/api/API';
import DynamicForm from '../../../../customformComponent/customForm/DynamicForm';
import './AddPurchaseOrder.scss'
export const AddVendorOnboard = () => {
  const [formData, setFormData] = useState({});
  const [ PaymentTermOptions, setPaymentTermOptions ] = useState([])
  const [validationErrors,setValidationErrors]= useState({})
  const [ vendoroptions, setVendorOptions ] = useState([])
  const token = localStorage.getItem("authToken");

  useEffect(()=>{
    vendortypeoptions()
      },[])
      const vendortypeoptions = async () => {
        try{
          const response = await axiosInstance.post("/vendortype/ddlvendortype",{
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
    
          const data = response.data.data.data
          const vendoroptions = data.map(user => ({
            value: user.ID,
            label:user.NAME,
          }))
          setVendorOptions(vendoroptions)
          const PaymentTermresponse = await axiosInstance.post("/paymentterm/ddlpaymentterm",{
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
    
          const Paymentdata = PaymentTermresponse.data.data.data
          const paymentoptions = Paymentdata.map(user => ({
            value: user.ID,
            label:user.NAME,
          }))
          console.log("paymentoptions",paymentoptions);
          
          setPaymentTermOptions(paymentoptions)
        }catch(error) {
          console.log(error)
        }
      }
    
      const handleFormSubmit = (data) => {
        console.log("Form Data:", data);
        setFormData({});
      };
    const VendorInputs = [
        {
          name: "vendortype",
          label: "Vendor Type",
          type: "dropdown",
          options:vendoroptions,
          required: true,
          gridClass: "col-lg-12",
        },
        {
          name: "companyname",
          label: "Vendor Name",
          type: "text",
          required: true,
          gridClass: "col-lg-12",
        },
        {
          name: "mobileno",
          label: "Mobile No.",
          type: "text",
          required: true,
          validation: { 
            required: true, pattern: /^[6-9]/ ,
            minLength:10,
            maxLength:10,
            message1: "Contact no should start with 6, 7, 8, 9",
            message: "Please enter a valid 10-digit",
          },
          gridClass: "col-lg-12",
        },
        {
          name: "emailid",
          label: "Email Address",
          type: "text",
          required: true,
          gridClass: "col-lg-12",
        },
        {
          name: "paymentterms",
          label: "Payment Term",
          type: "dropdown",
          required: true,
          options: PaymentTermOptions,
          gridClass: "col-lg-12",
          validation: { required: true },
        },
       
        {
          name: "bankname",
          label: "Bank Name",
          type: "text",
          placeholder:"Enter Bank Name",
          required: true,
          validation: { required: true,pattern: /^[a-zA-Z0-9 ]+$/, message: "Only Alphabets digits Are Allowed*", maxLength:25 },
          gridClass: "col-lg-12",
        },
        {
          name: "ifsc",
          label: "IFSC code",
          type: "text",
          placeholder:"Enter IFSC Code",
          required: true,
          validation: { required: true,pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/, message: "Please Enter Valid IFSC Code*",maxLength:12 },
          gridClass: "col-lg-12",
        },
        {
          name: "account_number",
          label: "Account Number",
          type: "text",
          placeholder:"Enter Account Number",
          required: true,
          validation: { required: true,pattern: /^\d{9,18}$/, message: "Please Enter valid Account Number",maxLength:18 },
          gridClass: "col-lg-12",
        },
     
        {
          name: "remark",
          label: "Remark",
          type: "text",
          required: true,
          placeholder:"Enter Remark",
          gridClass: "col-lg-12",
        },
      ];
  return (
    <div>
         <DynamicForm
          formConfig={VendorInputs}
          formData={formData}
          setFormData={setFormData}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
          onSubmit={handleFormSubmit} />
            <div className="savebtncontainer mt-3 gap-2">
          {/* <button style={{backgroundColor:"#fff", padding:"10px 20px" , borderRadius:"10px", color:"#7BD755", border:"1px solid #7BD755"}}>
      Back
  </button> */}
          <button
            onClick={() => handleFormSubmit(formData)}
            className="save-btn"
          >
            Save
          </button>
        </div>
    </div>
  )
}
